export default __webpack_public_path__ + "img/fGxHpAiQ.61a321e1.svg";